export default __webpack_public_path__ + "static/media/samsung_stimuli_phone.a5c379da.mp4";